import { SaveButton, Toolbar } from "react-admin";

const TestFingridCsvGenerationToolbar = ({ isLoading }: { isLoading: boolean }) => {
  return (
    <Toolbar>
      <SaveButton disabled={isLoading} />
    </Toolbar>
  );
};

export default TestFingridCsvGenerationToolbar;
